import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DeleteItem, SuccessfulDelete } from "../../components/modal";

const SubjectDetails = () => {
  const navigate = useNavigate();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openSuccessfulDeleteModal, setOpenSuccessfulDeleteModal] =
    useState(false);

  const handleDeleteSubject = () => {
    setOpenDeleteModal(true);
  };

  const cancelModal = () => setOpenDeleteModal(false);

  const confirmDelete = () => {

    setOpenDeleteModal(false);
    setOpenSuccessfulDeleteModal(true);
  };

  const closeSuccessfulDeleteModal = () => {
    setOpenSuccessfulDeleteModal(false);
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-md m-4">
      <div className="">
        <h1 className="text-[20px] font-bold text-[#400167] mb-6 font-satoshi">
          Subject Details
        </h1>
        <div className="flex">
          <div className="w-2/3 pr-6">
            <img
              src="/assets/shutterstock_2120376728 2.png" // Replace with the actual image source
              alt="Subject"
              className="mb-4 rounded w-[530.32px] h-[230.83px]"
            />
            <h2 className="text-[24px] text-[#400167] font-bold mb-2 font-satoshi">
              Subject Title
            </h2>
            <div className="w-[529.94px] text-[12px] text-[#000000] font-semibold">
              <p className="mb-4">
                Lorem ipsum dolor sit amet consectetur. Nibh urna massa luctus
                leo. Phasellus id eros fringilla aliquam rhoncus ac dictum
                sodales amet. Dignissim sem adipiscing lacinia dui nunc etiam
                augue.
              </p>
              <p className="mb-4">
                Aliquet arcu massa eu nulla. Non habitant sed sit erat non purus
                pellentesque dictumst tellus. Iaculis lectus in in consectetur
                in congue tellus. Elifend tellus ornare molestie feugiat et
                adipiscing. Turpis aliquet aliquam auctor purus tortor a augue
                dignissim. Elit pharetra nunc nibh at mollis.
              </p>
              <p className="mb-4">
                Porttitor au arcu eget pharetra sit sed condimentum. Nisl id
                ornare quis in. Fusce orci placerat nec amet ultrices. Urna cras
                consequat lorem ut et sagittis tristique rutrum viverra. Eu mi
                viverra aenean neque scelerisque pulvinar malesuada magna.
                Present adipiscing accumsan eget tellus odio magna habitant.
              </p>
              <p className="mb-4">
                Aenean facilisi imperdiet nunc tristique malesuada. Aenean a in
                commodo nunc pellentesque consequat vitae. Purus morbi pharetra
                velit adipiscing aliquam pharetra. Etiam cras eu.
              </p>
            </div>

            <div className="flex mt-20">
              <button
                onClick={() => navigate("/lessons/edit-subject")}
                className="bg-[#5002D0] hover:bg-purple-700 text-white font-semibold py-[10px] px-[18px] rounded mr-4 font-satoshi text-[16px] leading-[20px]"
              >
                Edit Subject
              </button>
              <button
                onClick={handleDeleteSubject}
                className=" text-[#E34033] text-[16px] font-semibold font-satoshi py-2 px-4 rounded"
                style={{ backgroundColor: "rgba(227, 64, 51, 0.2)" }}
              >
                Delete Subject
              </button>

              <DeleteItem isOpen={openDeleteModal} onClose={cancelModal}>
                <div>
                  <h1 className="text-[20px] text-[#400167] font-bold">
                    Delete Item?
                  </h1>
                  <p className="text-[14px] my-3">
                    Are you sure you want to delete ‘Item’? Action can not be
                    reversed.
                  </p>
                </div>
                <div className="flex items-center gap-4 mt-3">
                  <button
                    className="bg-[#5002D0] text-white text-[16px] font-medium py-3 px-4 rounded-lg w-[102px]"
                    onClick={confirmDelete}
                  >
                    Continue
                  </button>
                  <button
                    className="text-[16px] font-medium py-3 px-4 rounded-lg w-[87px] text-[#E34033]"
                    style={{ backgroundColor: "rgba(227, 64, 51, 0.2)" }}
                    onClick={cancelModal}
                  >
                    Cancel
                  </button>
                </div>
              </DeleteItem>

              <SuccessfulDelete
                isOpen={openSuccessfulDeleteModal}
                onClose={closeSuccessfulDeleteModal}
              />
            </div>
          </div>
          <div className="w-[428px] h-[704px] pl-4">
            <div className="bg-white rounded-lg p-6 mb-4 border border-[#25252525]">
              <div className="mb-4">
                <button className="bg-[#5002D0] hover:bg-purple-700 text-[16px] text-white font-semibold py-2 px-4 rounded mr-2">
                  Modules
                </button>
                <button className="bg-[#DDD3FF] hover:bg-purple-500 text-[16px] text-[#400167] font-semibold py-2 px-4 rounded">
                  Progress
                </button>
              </div>
              <div className="mt-8">
                {[...Array(10)].map((_, index) => (
                  <div
                    key={index}
                    className="flex justify-between items-center bg-[#FFFFFF] shadow-md py-2 p-2 mb-4 rounded"
                  >
                    <span className="text-[14px] font-satoshi font-semibold">
                      Topic {index + 1}
                    </span>
                    <Link
                      to="/lessons/course-detail"
                      className="text-purple-500"
                    >
                      {">"}
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubjectDetails;
